import request from '@/utils/request'

export function refundorderlist(data) {
  return request({
    url: '/api/out/refundOrder/list',
    method: 'post',
    data
  })
}

export function outbillorderimglist(data) {
  return request({
    url: '/api/out/dealerOutBillOrder/imglist',
    method: 'post',
    data
  })
}
export function signorderWeblist(data) {
  return request({
    url: '/api/out/terminalSignOrder/webList',
    method: 'post',
    data
  })
}
export function outbillorderweblist(data) {
  return request({
    url: '/api/out/dealerOutBillOrder/weblist',
    method: 'post',
    data
  })
}
export function terminalqrcodelist(data) {
  return request({
    url: '/api/out/terminalSignOrder/terminalQrcodeList',
    method: 'post',
    data
  })
}
export function signorderlist(data) {
  return request({
    url: '/api/out/terminalSignOrder/list',
    method: 'post',
    data
  })
}

// 渠道库存
export function stockChannel(data) {
  return request({
    url: '/api/out/stockChannel',
    method: 'post',
    data
  })
}
export function stockChannellog(data) {
  return request({
    url: '/api/out/stockChannel/log',
    method: 'post',
    data
  })
}
// 通过经销商编码查询经销商区域
export function merchantsChannelsAreaslist(data) {
  return request({
    url: '/api/out/merchantsChannelsAreas/list',
    method: 'post',
    data
  })
}
// 终端签收记录导出
export function outbillorderexpor(data) {
  return request({
    url: '/api/out/dealerOutBillOrder/expor',
    method: 'post',
    data
  })
}